import SexAgeStatistics from './SexAgeStatistics';

export default SexAgeStatistics;
